import { Stack, styled } from "@mui/material";

export const FlexRow = styled(Stack)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
}));
